import {reorderNo} from "app/configurator/utils/superseries/reorderNo";

export const separateExercises = (passedExercises, index) => {
    const exercises = [...passedExercises];
    const [exerciseToSeparate] = exercises.splice(index, 1);
    exerciseToSeparate._superseries.isLast = true;

    exercises.splice(index, 0, exerciseToSeparate);
    return reorderNo(exercises);
}